import { render, staticRenderFns } from "./SpecialityGroupList.vue?vue&type=template&id=32a69012&scoped=true&"
import script from "./SpecialityGroupList.vue?vue&type=script&lang=js&"
export * from "./SpecialityGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a69012",
  null
  
)

export default component.exports